import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const clientAuthHeaders = (token) => ({
  "Content-Type": "application/json",
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
});

export async function requestServiceHelper(payload, token) {
  const res = await axios.post(`${API}/portal/ai/service-helper`, payload, {
    headers: clientAuthHeaders(token),
  });
  return res.data;
}
